module.exports = __webpack_public_path__ + "img/button3.d4ead7de.png";